/* This file will be used to maintain the text translation */
export const gnTranslations = {
    verification:{
        verfnStart:'Verified accounts have red checkmarks next to their names to show that GNTunes has confirmed they’re real presence of the public figure and celebrities, they represent.',
        verfnPending:"Your application is under process now. Usually it takes 7-15 days to complete the process and provide a verification badge. Please have patience, we are always with you!",
        verfnRejected:"Your account wasn't verified because it doesn't match the eligibilities for account verification. You can again request to get our verification badge in next 30 days.",
        verfnApproved:'Wooooh! You have got the badge. Now let your audience know about your popularity and be with us to get some extra ordinary.',
    }
}
